import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FieldLabel from '../FieldLabel/FieldLabel';
import FieldMessages from '../FieldMessages/FieldMessages';

export default class Textarea extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    cols: PropTypes.number,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    id: PropTypes.string,
    infoMessage: PropTypes.string,
    label: PropTypes.string,
    maxLength: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onValidate: PropTypes.func,
    placeholder: PropTypes.string,
    registerField: PropTypes.func,
    required: PropTypes.bool,
    shouldRunValidators: PropTypes.bool,
    rows: PropTypes.number,
    validators: PropTypes.array,
    value: PropTypes.string,
    small: PropTypes.bool,
  };

  static defaultProps = {
    validators: [],
  };

  state = {
    touched: false,
  };

  componentDidMount = () => {
    const { registerField, name, defaultValue, value } = this.props;

    if (registerField) {
      registerField(name, defaultValue || value);
    }
  }

  componentDidUpdate = (prevProps) => {
    if (!prevProps.shouldRunValidators && this.props.shouldRunValidators) {
      this.attachValidators(this.runValidators.bind(this, this.inputField.value));
    }
  }

  handleChange = (e) => {
    const { value } = e.target;

    if (this.props.onChange) {
      this.props.onChange(this.props.name, value);
    }

    this.runValidators(value);
  };

  runValidators = (value) => {
    if (!this.state.touched) {
      return;
    }

    const errorMessage = this.validateField();
    const isValid = !errorMessage;

    if (this.props.onValidate) {
      this.props.onValidate(this.props.name, {
        errorMessage,
        isValid,
        value,
      });
    }
  };

  handleOnBlur = (e) => {
    const { value } = e.target;
    this.attachValidators(this.runValidators.bind(this, value));
  };

  attachValidators = (cb) => {
    this.setState({ touched: true }, cb);
  };

  validateField() {
    const { validators } = this.props;
    for (const validator of validators) {
      const isValid = validator.validator(this.inputField.value);
      if (!isValid) {
        return validator.message;
      }
    }
    return null;
  }

  render() {
    const {
      className,
      cols,
      defaultValue,
      disabled,
      errorMessage,
      id,
      infoMessage,
      label,
      maxLength,
      name,
      placeholder,
      required,
      rows,
      value,
      small,
    } = this.props;

    const uniqueId = id || name;
    const errorDescribedBy = `qr-${uniqueId}-error`;

    return (
      <div className="gn-textarea">
        <FieldLabel
          disabled={disabled}
          htmlFor={uniqueId}
          label={label}
          required={required}
        />

        <textarea
          id={uniqueId}
          name={name}
          cols={cols}
          rows={rows}
          ref={(inputField) => { this.inputField = inputField; }}
          onBlur={this.handleOnBlur}
          onChange={this.handleChange}
          aria-describedby={errorMessage ? errorDescribedBy : null}
          aria-invalid={!errorMessage}
          aria-required={required}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          className={classNames(
            'gn-textarea__field',
            className,
            {
              'gn-textarea__field--invalid': !!errorMessage,
              'gn-textarea__field--small': !!small,
            }
          )}
          maxLength={maxLength}
        />

        <FieldMessages
          errorMessage={errorMessage}
          infoMessage={infoMessage}
        />
      </div>
    );
  }
}
